<template>
  <span>
    <b-img
      :src="getQr(this.position)"
      @click.prevent="$bvModal.show('qr-modal-' + position.i)"
      class="clickable"
    ></b-img>
    <b-modal :id="'qr-modal-' + position.i" body-class="text-center" ok-title="Descargar" @ok="descargarPDF">
      <div id="areaImprimirQr">
        <b-img :src="qr.toDataURL()"></b-img>
        <h2>{{ this.position.name }}</h2>
      </div>
    </b-modal>
  </span>
</template>

<script>
import html2pdf from "html2pdf.js";
import QRious from "qrious";
export default {
  name: "QrModal",
  props: {
    position: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      qr: new QRious({ size: 400, value: this.position.name + "@" })
    };
  },
  methods: {
    getQr(position) {
      return new QRious({ size: 75, value: position.name + "@" }).toDataURL();
    },
    descargarPDF() {
      const element = document.getElementById("areaImprimirQr").innerHTML;
      const opt = {
        margin: 0.25,
        image: { type: "png" },
        filename: "reporte.pdf",
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
      };
      html2pdf(element, opt);
    }
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
